import React, { useEffect } from "react";
import Navbar from "../components/common/Navbar";
import ContactUs from "../components/HomePage/ContactUs";
import Footer from "../components/common/Footer";
import Landscape from "../assets/landscape.png";
import Landscape2 from "../assets/landscape3.png";
import AboutUs from "../components/HomePage/AboutUs";
import Advantage from "../components/HomePage/Advantage";
import Team from "../components/HomePage/Team";
import Benefits from "../components/HomePage/Benefits";
import Insights from "../components/HomePage/Insights";
import Expert from "../components/HomePage/Expert";
import Advisory from "../components/HomePage/Advisory";
import ServiceHighlights from "../components/HomePage/ServiceHighlights";
import Perspectives from "../components/HomePage/Perspectives";
import useThemeSwitcher from "../components/hooks/useThemeSwitcher";

const HomePage = () => {
  const [mode] = useThemeSwitcher();
  console.log(mode);
  return (
    <div className="flex relative flex-col h-full">
      <Navbar />

      {/* image content hero section */}
      <div className="relative flex items-center justify-start px-5 md:px-14 inset-0 z-[-1] w-full h-[70vh]  md:h-screen ">
        <img
          // src={mode === 'dark' ? Landscape2 : Landscape}
          src={Landscape}
          // src={Landscape2}
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover object-center z-[-1]"
        />
        <div className=" inset-0 z-10 text-white flex-col gap-5 flex items-start left-5 justify-center">
          <div className="font-thin flex flex-col gap-1 md:gap-3">
            <h1 className="text-3xl font-bold sm:text-4xl  md:text-6xl xl:text-7xl">
              Do More.
            </h1>
            <h1 className="text-3xl font-bold sm:text-4xl md:text-6xl xl:text-7xl ">
              Go Beyond.
            </h1>
          </div>
          <p className="font-semibold font-sans text-xl sm:text-2xl md:w-[80%] md:text-3xl">
            Redefine what your future looks like through technology
          </p>
        </div>
      </div>

      {/* contact us section */}

      <AboutUs />
      <div className="dark:bg-dark">
        <Advantage />
      </div>

      <Benefits />

      <Insights />

      <Expert />
      <div className="dark:bg-dark">
        <Advisory />
      </div>
      <ServiceHighlights />

      <Perspectives />
      <div className="dark:bg-dark">
        <Team />
      </div>

      <ContactUs />

      <Footer />
    </div>
  );
};

export default HomePage;
